module.exports = __webpack_public_path__ + "img/02-04-img-05.67d4f4e3.png";